// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"543":"ef898ac1","958":"d5037bfc"}[chunkId] + ".chunk.css";
};